import { request } from '@/shared/api/request'

export const getXml = (payload) => {
	return request({ url: 'colcontract/tradeUnion/get/xml', method: 'POST', data: payload })
}
